var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_3364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 18.3983C23.1933 18.3983 18.3333 23.2583 18.3333 29.2317C18.3333 35.17 23.1933 40 29.1667 40C35.14 40 40 35.14 40 29.1667C40 23.2283 35.14 18.3983 29.1667 18.3983ZM29.1667 38.3333C24.1133 38.3333 20 34.25 20 29.2317C20 24.1767 24.1133 20.065 29.1667 20.065C34.22 20.065 38.3333 24.1483 38.3333 29.1667C38.3333 34.2217 34.22 38.3333 29.1667 38.3333ZM31.4233 30.2433C31.7483 30.5683 31.7483 31.0967 31.4233 31.4217C31.26 31.585 31.0467 31.665 30.8333 31.665C30.62 31.665 30.4067 31.5833 30.2433 31.4217L28.5767 29.755C28.42 29.5983 28.3333 29.3867 28.3333 29.165V25.8317C28.3333 25.3717 28.7067 24.9983 29.1667 24.9983C29.6267 24.9983 30 25.3717 30 25.8317V28.82L31.4233 30.2433ZM32.5 3.33333H30V0.833333C30 0.373333 29.6267 0 29.1667 0C28.7067 0 28.3333 0.373333 28.3333 0.833333V3.33333H11.6667V0.833333C11.6667 0.373333 11.2933 0 10.8333 0C10.3733 0 10 0.373333 10 0.833333V3.33333H7.5C3.365 3.33333 0 6.69833 0 10.8333V32.5C0 36.635 3.365 40 7.5 40H17.5C17.96 40 18.3333 39.6267 18.3333 39.1667C18.3333 38.7067 17.96 38.3333 17.5 38.3333H7.5C4.28333 38.3333 1.66667 35.7167 1.66667 32.5V15H38.3333V17.5C38.3333 17.96 38.7067 18.3333 39.1667 18.3333C39.6267 18.3333 40 17.96 40 17.5V10.8333C40 6.69833 36.635 3.33333 32.5 3.33333ZM1.66667 13.3333V10.8333C1.66667 7.61667 4.28333 5 7.5 5H32.5C35.7167 5 38.3333 7.61667 38.3333 10.8333V13.3333H1.66667Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 11,
    fill: "#72B01D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 26L28.1201 29.5195C28.0444 29.8223 28.1144 30.143 28.3094 30.3867L30 32.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_3364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventManagementIcon);
export default __webpack_public_path__ + "static/media/event_management_icon.ae80ca8fbea4c62ae5528eb422a12b23.svg";
export { ForwardRef as ReactComponent };